import filled from './filled';
import outlined from './outlined';

export default {
	filled,
	outlined
};
